import React, { useState } from 'react';

import Slider from '../static/slider.png'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';

import Iconbutton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Appbar from '@material-ui/core/Appbar';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import MuiMenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {makeStyles,createMuiTheme,ThemeProvider} from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../actions/userActions';
import { Redirect } from 'react-router';
import { Link,useHistory} from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import { expertLogout } from '../actions/expertActions';


const theme = createMuiTheme({
    palette: {
        primary: {
          main: "#068213",
        },
        secondary: {
          main: "#ffffff",
        },
      },
})

const useStyles = makeStyles((theme)=>({
    root:{
        flexGrow:1,
        zIndex:"100",position:"fixed",
        width:"100vw",
        top:"0em"
    },
    butdiv:{
        flexGrow:1,
    },
    menuButton:{
        marginRight:theme.spacing(2),
    },
    title:{
        fontWeight:"700",
        marginRight:theme.spacing(2),
      
    },
    paper:{
        background:"rgba(255,255,255,0.5)",
        color:"#010101",
        width:"100%",
        zIndex:"5",
        border:"none",
        outline:"none",
        boxShadow:"none",
        textAlign:"center",
        flexGrow:1
    },
    menuitem:{
        width:"100%",
        color:"#010101",
        textAlign:"center",
        fontSize:"1.2em",
        padding:".5em 2em",
        fontWeight:"600"
    },
    menuicon:{
        margin:"0em .5em"
    },
    avatar:{
        height:theme.spacing(20),
        width:theme.spacing(20),
        background:"#f1f1f1",
        margin:"1em 0em",
        
    },
    avatardiv:{
        padding:"3em 0em",
        fontFamily:"Poppins, sans-serif"
    },
    paper1: {
        borderBottomRightRadius:"3em",
        borderTopRightRadius:"3em"

    }
}));


export default function NavBar(props) {
const mattheme = theme;
const [open,setOpen] = useState(false);
const [anchor,setAnchor] = useState(null);
const [placement,setPlacement] = useState(null);
const classes = useStyles();
const dispatch = useDispatch();
const history = useHistory();
const userSignin = useSelector(state=>state.userSignin);
const {loading,userInfo,error} = userSignin;
const expertSignin = useSelector(state=>state.expertSignin);
const {loading3,expertInfo,error3} = expertSignin;


const toggleDrawer = (open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setOpen(open);
  };


const handleLogout = (e) => {
    
    if(userInfo){
        dispatch(logout());
    }
    else if(expertInfo){
        dispatch(expertLogout());
    }
    history.push("/");
   
    toggleDrawer(false);
};



return(
        <div>
            <ThemeProvider theme={mattheme}>
            
            <SwipeableDrawer
            anchor={'left'}
            open={open}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
            classes={{paper:classes.paper1}}
            
            >
                {(userInfo || expertInfo)&&<Grid item container alignItems="center" justify="center" direction="column" className={classes.avatardiv}>
                <Avatar className={classes.avatar}  src="https://res.cloudinary.com/marcos-yash/image/upload/v1616877820/avatar1_kijavl_iopsya.png">
                </Avatar>
                <Typography variant="h5" style={{fontWeight:"600"}}>
                    {userInfo?userInfo.name:expertInfo.name}
                </Typography>
                </Grid>}
                 {
                     (!userInfo && !expertInfo)&&<Grid style={{padding:"2em 0em"}}>
                         <img style={{maxWidth:"15em"}} src={Slider}></img>
                     </Grid>
                 }
                <Paper className={classes.paper} >
                            <ClickAwayListener onClickAway={toggleDrawer(false)}>
                                <MenuList className={classes.menulist}>
                                <Link to="/" style={{textDecoration:"none"}}><MenuItem className={classes.menuitem} onClick={toggleDrawer(false)}><HomeRoundedIcon fontSize="large" className={classes.menuicon} />Home</MenuItem></Link>
                                <Link to="/" style={{textDecoration:"none"}}><MenuItem className={classes.menuitem} onClick={toggleDrawer(false)}><InfoOutlinedIcon fontSize="large" className={classes.menuicon} />About Us</MenuItem></Link>
                               { userInfo&&<div>
                                <Link to="/userprofile" style={{textDecoration:"none"}}><MenuItem className={classes.menuitem}  onClick={toggleDrawer(false)}><AccountCircleIcon fontSize="large" className={classes.menuicon} />Profile</MenuItem></Link>
                                <MenuItem style={{color:"red"}} className={classes.menuitem} onClick={handleLogout}><ExitToAppIcon fontSize="large" className={classes.menuicon}  />Logout</MenuItem>
                                </div>
                                }
                                { expertInfo&&<div>
                                <Link to="/expertprofile" style={{textDecoration:"none"}}><MenuItem className={classes.menuitem}  onClick={toggleDrawer(false)}><AccountCircleIcon fontSize="large" className={classes.menuicon} />Profile</MenuItem></Link>
                                <MenuItem style={{color:"red"}} className={classes.menuitem} onClick={handleLogout}> <ExitToAppIcon fontSize="large" className={classes.menuicon} />Logout</MenuItem>
                                </div>
                                }
                                <Link to="/contact" style={{textDecoration:"none"}}><MenuItem className={classes.menuitem} onClick={toggleDrawer(false)}><ContactSupportIcon fontSize="large" className={classes.menuicon} />Contact Us</MenuItem></Link>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
            </SwipeableDrawer>
            <div className={classes.root}>
            <Appbar position="static">
                <Toolbar>
                    <div className={classes.butdiv}>
                    <Iconbutton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
                        <MenuIcon fontSize="large" />
                    </Iconbutton>
                    </div>
                    <Typography variant="h5" className={classes.title} >
                        Dr.Crop
                    </Typography>
                </Toolbar>
            </Appbar>
            </div>
            </ThemeProvider>
            
        </div>
    );
}


